import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Removes toast message after 2.5 seconds or on button click.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <div data-controller="toast">
 *   <button data-action="click->toast#remove">Remove</button>
 * </div>
 */
export class Toast extends Controller {
    connect() {
        this.timeout = setTimeout(() => {
            this.remove();
        }, 2500);
    }
    disconnect() {
        if (this.timeout)
            clearTimeout(this.timeout);
    }
    remove() {
        this.element.remove();
    }
}
